// src/pages/battle/components/BattleHeader.jsx
import React from 'react';
import { UnitType } from '../../../utils/combatSystem';
import { getColorClasses } from '../../themeConfig';

const BattleHeader = ({
  activeMission,
  turn,
  turnCount,
  gameOver,
  endTurn,
  abortMission,
  alertColor,
  primaryColor
}) => {
  return (
    <div className={`bg-gray-900/80 backdrop-blur border-b-2 ${getColorClasses(alertColor, 'border')} sticky top-0 z-50`}>
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          <div>
            <h1 className={`text-2xl font-bold ${getColorClasses(alertColor)} tracking-wider`}>
              {activeMission.name}
            </h1>
            <p className="text-sm text-gray-400 font-mono">{activeMission.location}</p>
          </div>
          <div className="flex items-center gap-4">
            {!gameOver && (
              <div className={`text-xl font-bold ${
                turn === UnitType.SOLDIER 
                  ? getColorClasses(primaryColor) 
                  : getColorClasses(alertColor)
              }`}>
                {turn === UnitType.SOLDIER ? '🔵 YOUR TURN' : '🔴 ENEMY TURN'}
              </div>
            )}
            <div className="text-right">
              <p className="text-xs text-gray-400">TURN</p>
              <p className="font-bold text-yellow-400">{turnCount}</p>
            </div>
            {turn === UnitType.SOLDIER && !gameOver && (
              <button 
                onClick={endTurn} 
                className="bg-green-600 hover:bg-green-700 px-6 py-2 rounded font-bold transition-all"
              >
                END TURN
              </button>
            )}
            <button
              onClick={abortMission}
              disabled={gameOver}
              className="bg-gray-700 hover:bg-gray-600 disabled:bg-gray-800 disabled:text-gray-600 px-4 py-2 rounded font-bold text-sm transition-all"
            >
              ABORT
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BattleHeader;